module.exports = __webpack_public_path__ + "img/nav-design-hammered.c8434f4.jpg";